import script from "./AsidePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AsidePanel.vue?vue&type=script&setup=true&lang=ts"

import "./AsidePanel.vue?vue&type=style&index=0&id=a3e0b76a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3e0b76a"]])

export default __exports__